import React, { useState } from "react";
import "./SuccessPage.css";
import loginBgImage from "../../assets/images/Login_Page_bg.png";
import SuccessImg from "../../assets/images/Success_img.png";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const navigate = useNavigate();

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div className="login-container">
      <div
        className="login-left"
        style={{ backgroundImage: `url(${loginBgImage})` }}
      >
        <div className="mobile-wave">
          <svg
            className="mobile-wave-svg"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#f5f5f5"
              d="M0,224L80,202.7C160,181,320,139,480,154.7C640,171,800,245,960,250.7C1120,256,1280,192,1360,160L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      <div className="mid-curve">
        <svg
          className="mid-curve-svg"
          viewBox="0 0 520 1000"
          preserveAspectRatio="none"
        >
          <path
            d="
              M 520 0
              L 270 0
              C 220 70, 205 140, 245 210
              C 310 330, 175 430, 140 520
              C 100 640, 260 730, 275 840
              C 290 930, 225 1000, 170 1000
              L 520 1000
              Z
            "
            fill="#f5f5f5"
          />
        </svg>
      </div>

      <div className="login-right">
        <div className="login-card">
          <div className="login-logo">
            <img src={SuccessImg} alt="AstroCure" className="login-logo-image" />
          </div>

          <h1 className="success-title">Success!</h1>

            <div className="form-group">
              <div className="success-desc">
                Your password has been updated successfully.
              </div>
              <div className="success-desc">You can now log in using your new password.</div>

              <div className="floating-group">
                </div>
            </div>

            <button type="submit" className="verify-code-button" onClick={() => { navigate("/login");}}>
              Back to Login Page
            </button>
        </div>

        <footer className="login-footer">
          Copyright © 2026 Astrovidhi Private Limited All rights reserved
        </footer>
      </div>
    </div>
  );
};

export default SuccessPage;
